import showMessage from "../utils/alert"
import router from "@/router";
const setAuthDataInLocalStorage = (reponseBody) => {
    Object.keys(reponseBody).forEach(function(key) {
            localStorage.setItem(key, reponseBody[key]);
            // console.log("Key: ", key , "Value: ", localStorage.getItem(key))
        });

    setTimeout(function() {
        // Remove all keys from local storage
        clearSessionData()
        router.push({ name: 'login' });
        }, 60 * 60 * 1000); // 1 hour in milliseconds

}

const clearSessionData = ()=>{
    localStorage.setItem("IdToken", null)
    // localStorage.removeItem("IdToken")
    location.replace("/")
}
const clearLogoutData = ()=>{
    // localStorage.setItem("IdToken", null)
    localStorage.removeItem("IdToken")
    location.replace("/")
}

const isUserDataExist = ()=>{
    return localStorage.getItem("IdToken") !== null 
}

const getUserData = ()=>{
    return {
        IdToken: localStorage.getItem("IdToken")
    }
}

export {
    setAuthDataInLocalStorage,
    clearSessionData,
    clearLogoutData,
    isUserDataExist,
    getUserData

}
